//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.Product

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The product group model
* 
* @param groupId The product group id
* @param displayOptions The display options
* @param groupDescription The group description
* @param groupTitle The group title
* @param products The products in the group
*/
@Serializable

data class ProductGroup (


      /* The product group id */
    @SerialName(value = "groupId") @Required val groupId: kotlin.Int,


      /* The display options */
    @SerialName(value = "displayOptions") val displayOptions: kotlin.collections.List<kotlin.String>? = null,


      /* The group description */
    @SerialName(value = "groupDescription") val groupDescription: kotlin.String? = null,


      /* The group title */
    @SerialName(value = "groupTitle") val groupTitle: kotlin.String? = null,


      /* The products in the group */
    @SerialName(value = "products") val products: kotlin.collections.Set<Product>? = null


) {




  }

